/**
 * 模块名称: 客户新增审批 (认证)
 * @author zhuyan@372163.com
 */

import React from 'react'
import { Switch, Route } from 'react-router-dom'
import AddCustomerAudit from './AddCustomerAudit'
import AddCustomerDetail from './AddCustomerDetail'

const AddCustomerAuditIndex = ({ match, history }) => {

  return (
    <div>
      <Switch>
        <Route path={match.path + '/detail'} component={AddCustomerDetail} />
        <Route component={AddCustomerAudit} />
      </Switch>
    </div>
  )
}

export default AddCustomerAuditIndex